module.exports = __webpack_public_path__ + "img/japan-tuberculosis-male.b2d2fd61.png";